import {executeQueryUtil} from "./gqlUtil";
import {getProductsQuery} from "../gql/ProductGql";

export async function getProductsData(brandId, establishmentId) {
    let ret = [];
    const resProducts = await executeQueryUtil(getProductsQuery(brandId, establishmentId));

    const productsRaw = resProducts?.data?.getProducts;
    productsRaw.forEach(product => {
        ret.push(JSON.parse(product.content));
    })
    return ret
}